import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import CookieConsent from "react-cookie-consent";
import BannerPromotion from "./BannerPromotion";

import Header, {
  LogoLink,
  NavLinks,
  NavLink as NavLinkBase,
} from "../includes/light.js";

const StyledHeader = styled(Header)`
  ${tw`justify-between`}
  ${LogoLink} {
    ${tw` pb-0`}
  }
`;

const NavLink = tw(NavLinkBase)`
  sm:text-sm sm:mx-6 
`;

const Container = tw.div`relative -mx-8 -mt-8`;

export default class HeaderComponent extends React.Component {
  navLinks;
  logoLink;

  constructor(prop) {
    super(prop);
    this.navLinks = [
      <NavLinks key={1}>
        {prop.headerData.menus.map(function (page) {
          return (
            <NavLink
              key={page.id}
              href={page.slug !== "home" ? "/" + page.slug : "/"}
            >
              {page.name}
            </NavLink>
          );
        })}
      </NavLinks>,
    ];
    this.logoLink = (
      <LogoLink className="logo-wrapper" href="/">
        <img className="header-logo" src={prop.headerData.info.website_logo} alt="logo" />
        <em className="logo-text">
          <strong>{prop.headerData.heading_tile}</strong>
          <span>{prop.headerData.heading_info}</span>
        </em>
      </LogoLink>
    );
  }

  render() {
    return (
      <>
        <Container>
          <div className="header-btn-wrapper">
            <a href="/" className="btn btn-yellow">
              <strong> Reservation</strong>
            </a>
            <a href="tel:3406909330" className="btn btn-yellow">
              <strong>Call Us</strong>
            </a>
          </div>
          <StyledHeader
            links={this.navLinks}
            logoLink={this.logoLink}
            collapseBreakpointClass="sm"
          />
        </Container>
        <BannerPromotion />
        <CookieConsent
          location="bottom"
          buttonText="Allow"
          onAccept={() => {
            //alert("Cookie   Accepted");
          }}
          cookieName="myAwesomeCookieName2"
          style={{ background: "#ddd", color: "#000" }}
          buttonStyle={{
            background: "#038f04",
            color: "#fff",
            fontSize: "16px",
            padding: "10px 35px",
            fontWeight: "600",
          }}
          expires={150}
        >
          This website uses cookies. By using this website you consent to our
          use of these cookies. For more information visit our
          <a href="/cookie-policy"> Cookie Policy</a>
        </CookieConsent>
      </>
    );
  }
}
